import { Button, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@material-ui/core";
import moment from "moment";
import React, { Component } from "react";
import request from "superagent";
import LoaderSpinner from "../../componentes/LoaderSpinner";
import { tableRowBackground, url_endpoint } from "../../config";
import palette from "../../theme/palette";
import authHeader from "../Utils/AuthHeader";
import checkLogin from "../Utils/checkLogin";
import DateRangePickers from "./Dashboard/components/DateRangePickers";
import FirebaseService from "../../services/FirebaseService";
import ImageIconBox from "./components/ImageIconBox";
import headsetIcon from '../../images/icons/headset_icon.svg'

export default class TtsAudios extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            pedidos: [],
            searchedResults: null,
            dialogOpen: false,
            dialogPedidoSelected: null,
            dialogConfirmRecreateState: false,
            generalDialogDatas: [],
            blogToRegenerate: null,
            regeneratingBlogs: [],
            searchParam: '',
        }
        props.setTitulo('Áudios')
    }

    async setAudiosMetricsNull() {
        for (let i = 0; i < this.state.pedidos.length; i++) {
            const pedido = this.state.pedidos[i];
            pedido.totalShare = null
            pedido.totalReproducao = null
            pedido.totalDownload = null
        }

        if (this.state.searchedResults != null) {
            for (let i = 0; i < this.state.searchedResults.length; i++) {
                const pedido = this.state.pedidos[i];
                pedido.totalShare = null
                pedido.totalReproducao = null
                pedido.totalDownload = null
            }
        }
    }

    async searchAudios() {
        try {
            this.setState({ loading: true })

            const res = await request.get(url_endpoint + 'podcast/search/' + this.state.searchParam).set(authHeader())
            this.setState({ searchedResults: res.body, loading: false })

            this.setAudiosMetricsNull()
        } catch (e) {
            console.log(e)
            this.setState({ loading: false })
            const msg = e.response.text
            this.addGeneralDialogData('Erro ao buscar áudios', msg)
        }
    }

    async getAudioMetrics(pedido) {
        if (pedido.totalShare != null) {
            this.setState({ dialogOpen: true, dialogPedidoSelected: pedido })
            return
        }

        this.setState({ loading: true })
        let totalShare = 0;
        let totalReproducao = 0;
        let totalDownload = 0;
        try {
            //recupera todos os shares
            await FirebaseService.getDadosPlayer(
                pedido.id,
                "share_whatsapp",
                (rest) => {
                    console.log('rest share_whatsapp > ' + rest)
                    if (rest) totalShare = totalShare + rest;
                }
            );
        } catch (error) {
            console.log(error);
        }
        try {
            //recupera todos os shares
            await FirebaseService.getDadosPlayer(
                pedido.id,
                "share_facebook",
                (rest) => {
                    console.log('rest share_facebook > ' + rest)
                    if (rest) totalShare = totalShare + rest;
                }
            );
        } catch (error) {
            console.log(error);
        }
        try {
            //recupera todos os shares
            await FirebaseService.getDadosPlayer(
                pedido.id,
                "share_linkedin",
                (rest) => {
                    console.log('rest share_linkedin > ' + rest)
                    if (rest) totalShare = totalShare + rest;
                }
            );
        } catch (error) {
            console.log(error);
        }

        try {
            //recupera todos os shares
            await FirebaseService.getDadosPlayer(
                pedido.id,
                "share_twitter",
                (rest) => {
                    console.log('rest share_twitter > ' + rest)
                    if (rest) totalShare = totalShare + rest;
                }
            );
        } catch (error) {
            console.log(error);
        }

        try {
            await FirebaseService.getDadosPlayer(
                pedido.id,
                "play",
                (rest) => {
                    console.log('rest play > ' + rest)
                    if (rest) totalReproducao = totalReproducao + rest;
                }
            );
        } catch (error) {
            console.log(error);
        }

        try {
            await FirebaseService.getDadosPlayer(
                pedido.id,
                "download",
                (rest) => {
                    console.log('rest download > ' + rest)
                    if (rest) totalDownload = totalDownload + rest;
                }
            );
        } catch (error) {
            console.log(error);
        }

        pedido.totalShare = totalShare
        pedido.totalReproducao = totalReproducao
        pedido.totalDownload = totalDownload

        this.setState({ dialogOpen: true, dialogPedidoSelected: pedido, loading: false })
    }

    async componentDidMount() {
        try {
            await checkLogin(false)
            const today = new Date()
            // Subtract to Hours because the ISOString adds 3 hours to the date
            const startRange = new Date(today.getFullYear(), today.getMonth(), 1, -3)
            const endRange = new Date(today.getFullYear(), today.getMonth() + 1, 0, -3)
            const pedidos = await request.get(url_endpoint + "podcast/myTts/" + startRange.toISOString() + '/' + endRange.toISOString()).set(authHeader());
            this.setState({ pedidos: pedidos.body })
            await this.setAudiosMetricsNull()
            this.setState({ loading: false })
        } catch (e) {
            console.log(e)
            this.setState({ loading: false })
        }
    }

    changerangedata = async (startDate, endDate) => {
        this.setState({ loading: true })

        const startRange = moment(startDate).startOf('day').toDate()
        const endSelected = moment(endDate).startOf('day').toDate()

        endSelected.setHours(23, 59, 59)

        const pedidos = await request.get(url_endpoint + "podcast/myTts/" + startRange.toISOString() + '/' + endSelected.toISOString()).set(authHeader());
        this.setState({ pedidos: pedidos.body, searchedResults: null, searchParam: '' })
        await this.setAudiosMetricsNull()
        this.setState({ loading: false })
    }

    addGeneralDialogData(title, message) {
        const newDialogDatas = [...this.state.generalDialogDatas, { title: title, message: message }]

        this.setState({ generalDialogDatas: newDialogDatas })
    }

    async regenerateBlog() {
        const actualBlog = this.state.blogToRegenerate
        try {
            const generatingListAdd = [...this.state.regeneratingBlogs, actualBlog]
            this.setState({ regeneratingBlogs: generatingListAdd })

            const res = await request.post(url_endpoint + "cliente/regeneratePlugPodcast").set(authHeader()).field('blogId', actualBlog.id)

            const newId = res.body.newId
            const actualIndex = this.state.pedidos.indexOf(actualBlog)

            const generatingListRemove = this.state.regeneratingBlogs.filter((b) => b != actualBlog)

            this.state.pedidos[actualIndex].id = newId

            this.addGeneralDialogData('Sucesso', `O post "${actualBlog.titulo}" foi gerado com sucesso`)

            this.setState({ regeneratingBlogs: generatingListRemove })
        } catch (e) {
            const msg = e.response.text

            const generatingListRemove = this.state.regeneratingBlogs.filter((b) => b != actualBlog)

            this.setState({ regeneratingBlogs: generatingListRemove })
            this.addGeneralDialogData(`Ocorreu um erro ao gerar o post "${actualBlog.titulo}"`, msg)
        }
    }

    buildCard(pedido) {
        return <Paper style={{ margin: '20px 0', display: 'grid', gridTemplateColumns: '60% 40%', alignItems: 'center', width: '100%', padding: '10px' }}>
            <div style={{ padding: '0 5px' }}>
                <h1 style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '22px', marginBottom: '15px', color: palette.primary.main, fontWeight: 'bold' }}>{pedido.titulo}</h1>
                <span style={{ marginLeft: '5px', color: 'grey', fontSize: '18px', fontWeight: 'bold' }}>{pedido.characters} caracteres utilizados neste conteúdo</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                <span onClick={() => {
                    this.getAudioMetrics(pedido)
                }} style={{ cursor: 'pointer', margin: '5px', borderRadius: '5px', padding: '7px 10px', backgroundColor: palette.primary.main, fontSize: '14px', color: 'white' }}>Visualizar métricas</span>
                <a target="_blank" href={pedido.urlBlog} style={{ margin: '5px', borderRadius: '5px', padding: '7px 10px', backgroundColor: palette.primary.main, fontSize: '14px', color: 'white' }}>Acessar post</a>
                {this.state.regeneratingBlogs.includes(pedido) && <CircularProgress />}
                {!this.state.regeneratingBlogs.includes(pedido) && <span onClick={() => {
                    this.setState({ dialogConfirmRecreateState: true, blogToRegenerate: pedido })
                }} style={{ cursor: 'pointer', margin: '5px', borderRadius: '5px', padding: '7px 10px', backgroundColor: palette.primary.main, fontSize: '14px', color: 'white' }}>Regerar Post</span>}
            </div>
        </Paper>
    }

    buildTableRows(items) {
        const rows = []

        for (let i = 0; i < items.length; i++) {
            const pedido = items[i]
            rows.push(
                <TableRow style={{
                    backgroundColor: i % 2 == 0 ? tableRowBackground : 'transparent',
                }} key={pedido.id}>
                    <TableCell component="th" scope="row">
                        <a target="_blank" href={pedido.urlBlog} style={{ color: palette.primary.main, textDecoration: 'underline', textUnderlineOffset: '3px', fontSize: '17px', }}>{pedido.titulo}</a>
                    </TableCell>
                    <TableCell style={{ color: 'grey', fontSize: '17px', }} align="center">{moment(pedido.createdAt).format('DD/MM/YYYY')}</TableCell>
                    <TableCell style={{ color: 'grey', fontSize: '17px', }} align="center">{pedido.characters} caracteres</TableCell>
                    <TableCell align="right" style={{ paddingRight: '0' }}>
                        <div>
                            <span onClick={() => {
                                if (this.state.regeneratingBlogs.includes(pedido)) {
                                    return
                                }
                                this.getAudioMetrics(pedido)
                            }} style={{ textWrap: 'nowrap', cursor: 'pointer', margin: '5px', borderRadius: '5px', padding: '7px 10px', backgroundColor: palette.primary.main, fontSize: '14px', color: 'white' }}>Visualizar métricas</span>
                            {this.state.regeneratingBlogs.includes(pedido) && <CircularProgress />}
                            {!this.state.regeneratingBlogs.includes(pedido) && <span onClick={() => {
                                this.setState({ dialogConfirmRecreateState: true, blogToRegenerate: pedido })
                            }} style={{ textWrap: 'nowrap', cursor: 'pointer', margin: '5px', borderRadius: '5px', padding: '7px 10px', backgroundColor: palette.primary.main, fontSize: '14px', color: 'white' }}>Regerar Post</span>}
                        </div>
                    </TableCell>
                </TableRow>
            )
        }

        return rows
    }

    render() {
        return (
            <div>
                {this.state.loading &&
                    <LoaderSpinner />
                }
                <Dialog
                    open={this.state.generalDialogDatas.length > 0}
                    onClose={() => {
                        let newDialogDatas = this.state.generalDialogDatas
                        newDialogDatas.shift();
                        this.setState({ generalDialogDatas: newDialogDatas })
                    }}
                >
                    <DialogTitle>
                        <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>{this.state.generalDialogDatas.length > 0 ? this.state.generalDialogDatas[0].title : ''}</span>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <span style={{ fontSize: '14px' }}>{this.state.generalDialogDatas.length > 0 ? this.state.generalDialogDatas[0].message : ''}</span>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <span onClick={() => {
                            let newDialogDatas = this.state.generalDialogDatas
                            newDialogDatas.shift();
                            this.setState({ generalDialogDatas: newDialogDatas })
                        }} style={{ cursor: 'pointer', 'color': palette.primary.main, fontSize: '16px' }}>
                            {"OK"}
                        </span>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.dialogConfirmRecreateState}
                    onClose={() => {
                        const newRegeneratingList = this.state.regeneratingBlogs.filter((b) => b != this.state.blogToRegenerate)
                        this.setState({ dialogConfirmRecreateState: false, regeneratingBlogs: newRegeneratingList, blogToRegenerate: null })
                    }}
                >
                    <DialogTitle>
                        <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>{"Tem certeza que deseja regerar o post?"}</span>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <span style={{ fontSize: '14px' }}>Esta ação substituiŕa o áudio atual, e consumirá a sua quantidade correspondente de caracteres.</span>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ margin: '0 15px' }}>
                        <span onClick={() => {
                            const newRegeneratingList = this.state.regeneratingBlogs.filter((b) => b != this.state.blogToRegenerate)
                            this.setState({ dialogConfirmRecreateState: false, regeneratingBlogs: newRegeneratingList, blogToRegenerate: null })
                        }} style={{ cursor: 'pointer', 'color': palette.error.main, fontSize: '16px', marginRight: '10px' }}>
                            {"Cancelar"}
                        </span>
                        <span onClick={async () => {
                            this.setState({ dialogConfirmRecreateState: false })
                            await this.regenerateBlog()
                        }} style={{ cursor: 'pointer', 'color': palette.primary.main, fontSize: '16px' }}>
                            {"Regerar"}
                        </span>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.dialogOpen}
                    onClose={() => {
                        this.setState({ dialogOpen: false })
                    }}
                >
                    <DialogTitle>
                        <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>{"Métricas do Pedido"}</span>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <span style={{ fontSize: '14px' }}>Plays: {this.state.dialogPedidoSelected != null ? this.state.dialogPedidoSelected.totalReproducao : 0}</span>
                            <br />
                            <span style={{ fontSize: '14px' }}>Compartilhamento: {this.state.dialogPedidoSelected != null ? this.state.dialogPedidoSelected.totalShare : 0}</span>
                            <br />
                            <span style={{ fontSize: '14px' }}>Downloads: {this.state.dialogPedidoSelected != null ? this.state.dialogPedidoSelected.totalDownload : 0}</span>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <span onClick={() => {
                            this.setState({ dialogOpen: false })
                        }} style={{ cursor: 'pointer', 'color': palette.primary.main, fontSize: '16px' }}>
                            {"OK"}
                        </span>
                    </DialogActions>
                </Dialog>
                <h2 style={{ marginBottom: '20px' }}>Áudios publicados</h2>
                <Paper style={{ padding: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <ImageIconBox size='50px' padding='10px' src={headsetIcon}></ImageIconBox>
                        <div style={{ display: 'flex', alignItems: 'baseline', color: '#f2a404', marginBottom: '20px' }}>
                            <span style={{ fontSize: '16px' }}>Filtrar período:</span>
                            <CardHeader action={<DateRangePickers changerangedata={this.changerangedata}></DateRangePickers>} />
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
                        <TextField
                            onChange={(e) => {
                                this.state.searchParam = e.target.value
                                if (this.state.searchParam == '') {
                                    this.state.searchedResults = null
                                }
                                this.setState({})
                            }}
                            value={this.state.searchParam}
                            label="Pesquisar áudio"
                            variant='filled'
                            style={{ border: '1px solid lightgrey', borderRadius: '4px', backgroundColor: 'white', boxShadow: '0px 0px 2px grey' }}
                            InputProps={{ disableUnderline: true, style: { backgroundColor: 'white' } }}
                        ></TextField>
                        {this.state.searchParam.length > 0 &&
                            <Button
                                variant="contained"
                                onClick={() => this.searchAudios()}
                                color="primary"
                            >
                                Pesquisar
                            </Button>
                        }
                    </div>
                    <Grid
                        item
                        lg={12}
                        md={12}
                        xl={12}
                        xs={12}
                    >
                        <TableContainer>
                            <Table>
                                <TableHead style={{ backgroundColor: 'transparent', borderBottom: '2px solid lightgrey' }}>
                                    <TableRow>
                                        <TableCell style={{ color: 'grey' }}>Título</TableCell>
                                        <TableCell style={{ color: 'grey' }} align="center">Data</TableCell>
                                        <TableCell style={{ color: 'grey' }} align="center">Caracteres Utilizados</TableCell>
                                        <TableCell style={{ color: 'grey' }} align="center"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.buildTableRows(this.state.searchedResults ?? this.state.pedidos)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Paper>
            </div >
        )
    }
}